<div class="flex gap-2 items-center">
  @switch (userStatus()) {
    @case ('ACTIVE') {
      <mat-icon
        fontIcon="check_circle"
        class="text-proffeo-success! opacity-75"
      />
      <p>{{ 'user-status.active' | translate }}</p>
    }
    @case ('INACTIVE') {
      <mat-icon
        fontIcon="mail_lock"
        class="opacity-75 icon-warning"
      />
      <p>{{ 'user-status.inactive' | translate }}</p>
    }
    @case ('LOCKED') {
      <mat-icon
        fontIcon="lock"
        class="text-proffeo-danger! opacity-75"
      />
      <p>{{ 'user-status.locked' | translate }}</p>
    }
    @case ('DELETED') {
      <mat-icon
        fontIcon="delete"
        class="opacity-75"
      />
      <p>{{ 'user-status.deleted' | translate }}</p>
    }
  }
</div>
